import Container from 'react-bootstrap/Container';
import { Row, Col, Button } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import virtual from '../../../assets/img/virtual.png';
import loquiero from '../../../assets/img/quiero.png';
import background from '../../../assets/img/background.png';
// eslint-disable-next-line no-unused-vars
import styles from './style.module.scss';

const Planes = () => (
    <section>
        <Container className={styles.container}>
            <div className={styles.background} style={{ backgroundImage: `url(${background})` }}>
                <h2 className={`text-center ${styles.title}`}>¡En SEARS encontrarás la mesa de regalos perfecta para ti!</h2>
                <p className={`text-center ${styles.subtitle}`}>¿Buscas la mesa de regalos perfecta para tu evento especial? Te ofrecemos dos opciones para ti:</p>
                <div className={styles['cards-container']}>
                    <Card className={styles['card-box']}>
                        <Card.Body>
                            <Card.Title><p className={`text-center ${styles.card__title}`}><strong>PLAN VIRTUAL</strong></p></Card.Title>
                            <Card.Text>
                                <div className="text-center">
                                    <img src={virtual} alt="" className={styles.Formatimg} />
                                </div>
                                <p className={styles.description}><br />Recibe tus regalos en un <strong>monedero electrónico</strong> y úsalo para hacer compras en tiendas SEARS o en el sitio web.</p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className={styles['card-box']}>
                        <Card.Body>
                            <Card.Title><p className={`text-center ${styles.card__title}`}><strong>PLAN LO QUIERO</strong></p></Card.Title>
                            <div className="text-center">
                                <img src={loquiero} alt="" className={styles.Formatimg} />
                            </div>
                            <Card.Text>
                                <p className={styles.description}><br />Todos los regalos que recibas se <strong>envían</strong> al domicilio totalmente <strong>GRATIS</strong>.<br /></p>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
                <p>Regalo de bienvenida en eventos de Boda, Baby Shower, XV Años, Primera Comunión y Bautizo. (Aplica monto mínimo de compra para canje del obsequio).</p>
                <Link className={`link-button ${styles['link-container']}`} to="/planes">
                    <Button size="lg" block variant="primary" className={styles.button}>
                        Ver Planes
                    </Button>
                </Link>
            </div>
        </Container>
    </section >
);


export default Planes;